// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
var RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

var Types = {};

function unwrap_response_renewRentalNeed(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["RentalNeedRenewed"]);
}

var variablesConverter = {};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

var wrapResponseConverter = {"__root":{"renewRentalNeed_RentalNeedRenewed_rentalNeed":{"f":""},"renewRentalNeed":{"u":"response_renewRentalNeed"}}};

var wrapResponseConverterMap = {
  response_renewRentalNeed: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

var responseConverter = {"__root":{"renewRentalNeed_RentalNeedRenewed_rentalNeed":{"f":""},"renewRentalNeed":{"u":"response_renewRentalNeed"}}};

var responseConverterMap = {
  response_renewRentalNeed: unwrap_response_renewRentalNeed
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

var Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

var Utils = {};

var node = ((function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "nodeId"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "nodeId",
        "variableName": "nodeId"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "statusChangeComment",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RenewRentalNeedMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "renewRentalNeed",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RentalNeedV5",
                "kind": "LinkedField",
                "name": "rentalNeed",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "RenterPageHeader_StatusChangeButton_rentalNeedV5"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "RenterPageStatusCallout_rentalNeedV5"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ClientPageMatchingStatusLabel_matchable"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ChangeRentalNeedStatus_rentalNeedV5"
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "RentalNeedRenewed",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RenewRentalNeedMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "renewRentalNeed",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RentalNeedV5",
                "kind": "LinkedField",
                "name": "rentalNeed",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "status",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isRenewable",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "activeUntil",
                            "storageKey": null
                          }
                        ],
                        "type": "ActiveRentalNeed",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "expiredAt",
                            "storageKey": null
                          }
                        ],
                        "type": "ExpiredRentalNeed",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "withdrawnAt",
                            "storageKey": null
                          },
                          (v4/*: any*/)
                        ],
                        "type": "WithdrawnRentalNeed",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "statusChangedAt",
                            "storageKey": null
                          }
                        ],
                        "type": "RentedRentalNeed",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ExpiryInfoV5",
                    "kind": "LinkedField",
                    "name": "expiryInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "activePeriodInDays",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Renter",
                    "kind": "LinkedField",
                    "name": "client",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "displayName",
                        "storageKey": null
                      },
                      (v5/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "activelyMatching",
                        "storageKey": null
                      }
                    ],
                    "type": "Matchable",
                    "abstractKey": "__isMatchable"
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "RentalNeedRenewed",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6c27d9f80135a4c557bdbc2b98e3ebd6",
    "id": null,
    "metadata": {},
    "name": "RenewRentalNeedMutation",
    "operationKind": "mutation",
    "text": "mutation RenewRentalNeedMutation(\n  $nodeId: ID!\n) {\n  renewRentalNeed(input: {nodeId: $nodeId}) {\n    __typename\n    ... on RentalNeedRenewed {\n      rentalNeed {\n        ...RenterPageHeader_StatusChangeButton_rentalNeedV5\n        ...RenterPageStatusCallout_rentalNeedV5\n        ...ClientPageMatchingStatusLabel_matchable\n        ...ChangeRentalNeedStatus_rentalNeedV5\n        nodeId\n      }\n    }\n  }\n}\n\nfragment ChangeRentalNeedStatus_rentalNeedV5 on RentalNeedV5 {\n  id\n  nodeId\n  status {\n    __typename\n    ... on ActiveRentalNeed {\n      isRenewable\n      activeUntil\n    }\n    ... on ExpiredRentalNeed {\n      expiredAt\n    }\n  }\n  expiryInfo {\n    activePeriodInDays\n  }\n  client {\n    displayName\n    id\n    nodeId\n  }\n}\n\nfragment ClientPageMatchingStatusLabel_matchable on Matchable {\n  __isMatchable: __typename\n  __typename\n  activelyMatching\n}\n\nfragment ExpiredRentalNeedCallout_expiredRentalNeed on ExpiredRentalNeed {\n  expiredAt\n}\n\nfragment ExpiringRentalNeedCallout_activeRentalNeed on ActiveRentalNeed {\n  activeUntil\n}\n\nfragment RentedRentalNeedCallout_rentedRentalNeed on RentedRentalNeed {\n  statusChangeComment\n  statusChangedAt\n}\n\nfragment RenterPageHeader_StatusChangeButton_rentalNeedV5 on RentalNeedV5 {\n  nodeId\n  status {\n    __typename\n    ... on ActiveRentalNeed {\n      isRenewable\n    }\n    ... on ExpiredRentalNeed {\n      __typename\n    }\n    ... on WithdrawnRentalNeed {\n      __typename\n    }\n    ... on RentedRentalNeed {\n      __typename\n    }\n  }\n}\n\nfragment RenterPageStatusCallout_rentalNeedV5 on RentalNeedV5 {\n  nodeId\n  status {\n    __typename\n    ... on ActiveRentalNeed {\n      isRenewable\n      ...ExpiringRentalNeedCallout_activeRentalNeed\n    }\n    ... on ExpiredRentalNeed {\n      ...ExpiredRentalNeedCallout_expiredRentalNeed\n    }\n    ... on WithdrawnRentalNeed {\n      ...WithdrawnRentalNeedCallout_withdrawnRentalNeed\n    }\n    ... on RentedRentalNeed {\n      ...RentedRentalNeedCallout_rentedRentalNeed\n    }\n  }\n}\n\nfragment WithdrawnRentalNeedCallout_withdrawnRentalNeed on WithdrawnRentalNeed {\n  withdrawnAt\n  statusChangeComment\n}\n"
  }
};
})());

var wrap_response_renewRentalNeed = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_renewRentalNeed = unwrap_response_renewRentalNeed;
exports.wrap_response_renewRentalNeed = wrap_response_renewRentalNeed;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
